import { InvitationType } from "@/api";
import { Meeting, Invitation } from "@/components/types";

export function getDownloadSource(): string {
    if (navigator.userAgent.search("Android") > -1) {
        return window.concertoDownloadLink.android;
    }

    if (navigator.userAgent.search("iPhone") > -1) {
        return window.concertoDownloadLink.iphone;
    }

    if (navigator.userAgent.search("Linux") > -1) {
        return window.concertoDownloadLink.linux;
    }

    if (navigator.userAgent.search("Windows") > -1) {
        return window.concertoDownloadLink.windows;
    }

    if (navigator.userAgent.search("Mac") > -1) {
        return window.concertoDownloadLink.mac;
    }
    return "";
}

export const getSipConferenceNumbers = () => {
    return window.conferenceNumbers.filter((value) => value.search("@") > -1);
};

export const getTelConferenceNumbers = () => {
    return window.conferenceNumbers.filter((value) => value.search("[+]") > -1);
};

export function getConferenceUri(participantIdentifier: string) {
    const conferenceNumber = window.conferenceNumbers[0];
    return `${conferenceNumber};participant=${participantIdentifier}`;
}

export function getConcertoJoinLinkHref(meeting: Meeting, invitation: Invitation): string {
    const queryParams: Record<string, string> = {
        target: getConferenceUri(invitation.uuid),
        identifier: `${invitation.id}@${window.tequet.mixerDomain}`,
        summary: meeting.summary,
        chatto: window.chattoBaseUrl,
    };

    if (window.tequet?.sipUri) queryParams.outbound_proxy = window.tequet.sipUri;

    if (!invitation.name || invitation.isAutoGenerated) queryParams.name_requested = "1";

    const queryParamsString = new URLSearchParams(queryParams).toString();

    return `${window.concertoClientJoinBaseUrl}?${queryParamsString}`;
}

export const getInvitationIdentifier = (invitations: Invitation[]): string => {
    return getCurrentInvitation(invitations).uuid;
};

export const getCurrentInvitation = (invitations: Invitation[]): Invitation => {
    const urlParams = new URLSearchParams(window.location.search);
    const invitation = urlParams.get("invitation");
    if (invitation) {
        for (const inv of invitations) {
            if (inv.uuid === invitation) return inv;
        }
    }

    for (const inv of invitations) {
        if (inv.type === InvitationType.Host && inv.isAutoGenerated) return inv;
    }

    throw new Error(
        "No valid invitation found - none in the current request uri and there are no HOSTs in the invitation list",
    );
};
